"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (process.env.NODE_ENV === 'production' && typeof fathom !== 'undefined') {
    fathom('trackPageview');
  }
};